module.exports = __webpack_public_path__ + "img/9791158880026.7aad2d34.jpg";